import { useCallback, useEffect, useState } from "react";
import { isBrowser } from "@fwa/src/utils/browserUtils";

const useIsTabActive = () => {
  const [isTabVisible, setIsTabVisible] = useState(false);

  const handleVisibilityChange = useCallback(() => {
    setIsTabVisible(document.visibilityState === "visible");
  }, []);

  useEffect(() => {
    if (isBrowser) {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }
    return () => {
      if (isBrowser) {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
      }
    };
  }, [handleVisibilityChange]);

  return isTabVisible;
};

export default useIsTabActive;
